import {createFeatureSelector, createSelector} from '@ngrx/store';
import _ from 'lodash'; 
import { tableState } from '../common/types/table/table-state.type';
import { inhibitionConnectivityFeatureKey } from './inhibition-connectivity.reducer';

const selectInhibitionConnectivityState = createFeatureSelector<tableState>(inhibitionConnectivityFeatureKey);

export const selectInhibitionConnectivityForm = createSelector(
    selectInhibitionConnectivityState,
    state => _.cloneDeep(state) // Désactive l'immutabilité des données. Ce qui permettra de les modifier dans les composants
);
